import { render, staticRenderFns } from "./ProjectItemPopover.vue?vue&type=template&id=792be651&"
import script from "./ProjectItemPopover.vue?vue&type=script&lang=ts&"
export * from "./ProjectItemPopover.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItemPopover.vue?vue&type=style&index=0&id=792be651&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports